import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { selectAccount } from "../mad-auth/mad-auth.store";
import { filter, map } from "rxjs/operators";
import { slugify } from "../v2/utils/slugify";
import { getWindow } from "../mad-auth/mad-auth.service";

@Injectable({
  providedIn: 'root'
})
export class SubdomainService {
  // private _subdomain: string;
  private _outseta: any;
  private _user: any;

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
    const window = getWindow()
    // const link = window.location.href
    // const {hostname} = new URL(link)
    // const [subdomain] = hostname.split('.')

    // this._subdomain = subdomain
    this._outseta = window['Outseta']
    if (this._outseta !== undefined) {
      this._outseta.getUser().then(
        (user) => {this._user = user}
      )
    }
  }

  public get subDomain() {
    const link = window.location.href
    const {pathname} = new URL(link)
    const org = this.getOrgSegment(pathname)
    if (org === null) {
      if (this._user === undefined) return 'app'
      return slugify(this._user.Account?.Name ?? 'app')
    }
    return org;
  }

  private getOrgSegment(pathname: string): string | null {
    const segments = pathname.split('/').filter(Boolean)
    if (segments[0] !== 'org' || segments.length < 2) {
      return null
    }
    return segments[1]
  }

  public get channelTenant() {
    const subDomain = this.subDomain
    if (subDomain === 'demo') return subDomain;

    if (this._user === undefined) {
      return localStorage.getItem('auid') ?? null;
    }
    const accountName = slugify(this._user.Account?.Name ?? 'demo')
    if (accountName === 'demo') return 'demo'
    return this._user.Account?.Uid ?? null
  }
}